<template>
  <div v-if="welcome">
    {{ notify() }}
  </div>
</template>
<script>
import swal from "sweetalert2";

export default {
  computed: {
    welcome() {
      return this.$store.state.registration.welcome_msg;
    },
  },
  methods: {
    notify() {
      swal.fire({
        type: "success",
        title: "Welcome!",
        html:
          "<h5>Please wait!</h5><br/><h5>You are being redirected to the Dashboard.</h5><br/>",
        showConfirmButton: false,
      });
    },
  },
};
</script>
